/* eslint-disable */
import axios from "axios";
import store from "../store"

const apiClient = axios.create({
    baseURL: "http://localshost:3000",
    withCredentials: false,
    headers:{
        Accept: "Application/json",
        "Content-Type": "application/json"
    }
});


export default {

    sendLRS(verb, data = ''){
        let userData = store.getters.user;
        if (typeof userData === 'string' || userData instanceof String){
            userData = JSON.parse(userData)
        }
        let userProgress = 0;

        if (verb === 'experienced') {
            store.dispatch('updateModuleStatus', data)
        }
        if(verb === 'mastered'){
            console.log(data);
            store.dispatch('updateModuleMastered',data);
        }
        // count chapter progress
        if (verb === 'progressed') {
            console.log(store.getters.moduleStatus.length);
            console.log( store.getters);
            console.log(store.getters.moduleStatus.length / store.getters.maxChapters)
            userProgress = (store.getters.moduleStatus.length / store.getters.maxChapters) * 100;
            store.dispatch('updateModulePercent', Math.floor(userProgress));
        }

        let lrsUrl = "https://www.discover-shiseido.com/Module/LRS/post/";

        /* Sending data for Experience */
        let formData = new FormData();
        formData.set('context[platform]', userData.platform)
        formData.set('context[revision]', "1.0")
        formData.set('context[language]', userData.user.language)

        formData.set('actor[domain]', userData.user.domain)
        formData.set('actor[id]', userData.user.id)

        formData.set('verb[id]', verb)

        switch (verb) {
            case 'launched':
                formData.set('object[id]', 1)
                break;
            case 'experienced':
                formData.set('object[id]', data)
                break;
            case 'progressed':
                formData.set('object[id]', Math.floor(userProgress))
                break;

            case 'attempted01':
                formData.set('object[id]', 'quiz')
                break;
            case 'attempted02':
                formData.set('object[id]', 'quiz')
                break;
            case 'attempted03':
                formData.set('object[id]', 'quiz')
                break;
            case 'scored01':
                formData.set('object[id]', data)
                break;
            case 'scored02':
                formData.set('object[id]', data)
                break;
            case 'scored03':
                formData.set('object[id]', data)
                break;
            case 'scored':
                formData.set('object[id]', data)
                break;

            case 'mastered':
                formData.set('object[id]', data)
                break;
        }

        axios({
            method: 'post',
            url: lrsUrl,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data' }
        })

    },

}



